<template>
  <v-dialog
    @click:outside="handleClose"
    dark
    v-model="localDialog"
    max-width="500px"
    transition="dialog-bottom-transition"
    :persistent="isMandatory" 
    :loading="twoFactorData">
    <v-card class="d-flex justify-center flex-column align-center pa-12">
      <p class="font-weight-medium">
        Escaneie o QRCode no seu app de autenticação e ative com o código apresentado.
      </p>
      <img
        v-if="twoFactorData.qr_code"
        width="300px"
        class="mt-10 mb-10"
        :src="'data:image/png;base64,' + twoFactorData.qr_code" />
      <v-progress-circular 
        v-else 
        indeterminate 
        color="yellow" 
        class="mt-10 mb-10">
      </v-progress-circular>

      <v-text-field
        outlined
        type="number"
        label="Código"
        maxlength="6"
        autocomplete="off"
        style="max-width: 300px; font-size: 30px; letter-spacing: 10px !important"
        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
        @keyup.enter="activate2Fa()"
        v-model="code"></v-text-field>
      <v-btn
        large
        width="75%"
        :loading="loading"
        :disabled="loading"
        @click="activate2Fa()">Ativar</v-btn>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { twoFaByUser, activate2FaByUser } from "@/services/user";
import { saveAuthToken } from "@/utils/token";

const ACTIVATE_2FA_ERROR_MESSAGES: Record<number, string> = {
  4003: "Código inválido ou expirado. Confira o código exibido no app autenticador (da entrada correspondente ao QR atual) e o horário do seu celular.",
  4011: "Sessão expirada. Recarregue a página e tente novamente.",
  4012: "Sessão expirada. Recarregue a página e tente novamente.",
  4014: "O 2FA já está ativo para este usuário.",
};

export default defineComponent({
  props: {
    me: {
      type: Object,
      required: true,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
    isMandatory: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      twoFactorData: {
        qr_code: "",
        totp_key: "",
      },
      code: null,
      loading: false,
      value: 0,
    };
  },
  computed: {
    localDialog: {
      get(): boolean {
        return this.dialog;
      },
      set(val: boolean) {
        if (!val) this.$emit("close");
      },
    },
  },
  watch: {
    dialog: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          twoFaByUser().then((_2fa: any) => {
            this.twoFactorData = _2fa.data;
          }).catch((err) => {
            console.log(err);
            this.$emit("snackbar", {
              message: "Não foi possível gerar o QR Code. Feche e abra novamente.",
              color: "red",
            });
          });
        } else {
          this.code = null;
        }
      }
    },
  },
  methods: {
    activate2Fa(): void {
      if (this.loading) return;
      if (!this.twoFactorData.totp_key) {
        this.$emit("snackbar", {
          message: "O QR Code ainda não foi carregado. Aguarde um instante e tente novamente.",
          color: "red",
        });
        return;
      }
      if (!/^\d{6}$/.test(String(this.code ?? ""))) {
        this.$emit("snackbar", {
          message: "Informe o código de 6 dígitos exibido no app autenticador.",
          color: "red",
        });
        return;
      }
      this.loading = true;
      const payload = {
        code: this.code,
        totp_key: this.twoFactorData.totp_key,
        _2fa: "TOTP",
      };
      activate2FaByUser(payload)
        .then((_2fa: any) => {
          saveAuthToken(_2fa.data.token);
          this.$emit("snackbar", {
            message: "2FA foi ativado",
          });
          // this.me._2fa = "TOTP";
          
          this.$emit("success"); 
        })
        .catch((error) => {
          console.error(error);
          const code = Number(error?.response?.data?.errors?.[0]?.code);
          const message =
            ACTIVATE_2FA_ERROR_MESSAGES[code] ||
            "Não foi possível ativar o 2FA. Tente novamente.";
          this.$emit("snackbar", { message, color: "red" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleClose() {
    if (this.isMandatory) {
      return;
    }
    this.$emit("close");
    },
  },
});
</script>
